(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js');
"use strict";

const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useCouponContext
} = svs.components.tipsen.couponComponents;
const {
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  makeSelectEventOutcomesFromBitmap
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  Coupon
} = svs.components.tipsen.couponComponents;
const {
  useIsTipsinfoEnabled
} = svs.components.tipsen.hooks;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const formatDistributionValue = value => value ? "".concat(value, "%") : '0%';
const EventParticipantOutcome = _ref => {
  let {
    distributions,
    eventNumber,
    eventTypeId,
    outcomeGroupIndex,
    sportType
  } = _ref;
  const {
    couponId
  } = useCouponContext();
  const outcomeLabels = useMemo(() => getOutcomeLabelsForEventType(eventTypeId, sportType), [eventTypeId, sportType]);
  const selectOutcomes = useMemo(makeSelectEventOutcomesFromBitmap, []);
  const boardIndex = 0;
  const selections = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, outcomeGroupIndex));
  const {
    isSvenskaFolketAsOutcomesEnabled
  } = useIsTipsinfoEnabled();
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const shouldPairDistributionWithOutcomes = isSmallDevice && !isSvenskaFolketAsOutcomesEnabled;
  const outcomes = useMemo(() => {
    const outcomesArray = outcomeLabels.map((outcome, index) => ({
      sign: isSvenskaFolketAsOutcomesEnabled ? formatDistributionValue(distributions === null || distributions === void 0 ? void 0 : distributions[index]) : outcome.text,
      isSelected: Boolean(selections[index])
    }));
    return [...outcomesArray];
  }, [distributions, isSvenskaFolketAsOutcomesEnabled, outcomeLabels, selections]);
  return React.createElement(Coupon.BetButtons, {
    boardIndex: boardIndex,
    className: "pg_coupon_row__event__participant__outcome__bet_buttons_grid",
    distributions: shouldPairDistributionWithOutcomes ? distributions : [],
    eventNumber: eventNumber,
    isClickable: true,
    outcomeGroupIndex: outcomeGroupIndex,
    outcomes: outcomes
  });
};
setGlobal('svs.components.tipsen.couponScore.EventParticipantOutcome', EventParticipantOutcome);

 })(window);